module.exports = __webpack_public_path__ + "media/maddy_home.1c54e0ac.wav";